module.exports = __webpack_public_path__ + "static/media/ic_hs_main.5ef104b4.svg";